export const fr = {
  employeesPage: {
    title: 'Employés',
    helmet: {
      title: 'Employés',
      invitesTitle: 'Employés › Invitations',
    },
    table: {
      searchPlaceholder: 'Rechercher des employés',
      columns: {
        name: 'Nom',
        role: 'Rôle',
        lastActive: 'Dernière activité',
        causePreferences: 'Préférences de cause',
        department: 'Département',
        email: 'Courriel',
        status: 'Statut',
        employmentType: "Type d'emploi",
      },
      roles: {
        admin: 'Administrateur',
        employee: 'Employé',
        deactivated: 'Désactivé',
      },
      employmentTypes: {
        salaried: 'Salarié',
        union: 'Syndiqué',
        unassigned: 'Non assigné',
      },
      actions: {
        makeAdmin: 'Nommer administrateur',
        removeAdmin: "Retirer les droits d'administrateur",
        deactivate: "Désactiver l'employé",
        activate: "Activer l'employé",
        updateEmploymentType: "Mettre à jour le type d'emploi",
        copyEmail: 'copié dans votre presse-papiers',
      },
    },
    emptyState: {
      title: 'Aucun employé pour le moment',
      description:
        "Il semble que vous n'ayez pas encore ajouté d'employés.\nAjoutez des employés pour commencer à collaborer avec votre équipe !",
    },
    invites: {
      emptyState: {
        title: "Aucune invitation n'a encore été envoyée",
        description:
          'Invitez des employés à rejoindre Purposely et commencez à faire du bénévolat ensemble !',
      },
      status: {
        invited: 'Invité',
        fulfilled: 'Accepté',
      },
    },
    buttons: {
      inviteEmployee: 'Inviter un employé',
      all: 'Tous',
      invited: 'Invités',
    },
    modals: {
      updateAdmin: {
        title: "Mettre à jour les droits d'administrateur",
        removeConfirm:
          "Êtes-vous sûr de vouloir retirer les droits d'administrateur de {{name}} ?",
        makeConfirm:
          'Êtes-vous sûr de vouloir faire de {{name}} un administrateur de votre entreprise ?',
        buttons: {
          cancel: 'Non',
          confirm: 'Oui',
        },
        messages: {
          success: "Droits d'administrateur mis à jour avec succès",
          error: "Impossible de mettre à jour l'employé. Réessayez plus tard.",
        },
      },
      updateEmploymentType: {
        title: "Mettre à jour le type d'emploi",
        description: "Sélectionnez le type d'emploi pour {{name}}",
        types: {
          salaried: 'Salarié',
          union: 'Syndiqué',
        },
        buttons: {
          cancel: 'Annuler',
          confirm: 'Mettre à jour',
        },
        messages: {
          success: "Type d'emploi mis à jour avec succès",
          error:
            "Impossible de mettre à jour le type d'emploi. Réessayez plus tard.",
        },
      },
      changeActive: {
        title: {
          deactivate: "Désactiver l'employé",
          activate: 'Activer le compte',
        },
        confirm: {
          deactivate:
            "Êtes-vous sûr de vouloir désactiver {{name}} ? Cela lui fera perdre l'accès à son compte.",
          activate:
            'Êtes-vous sûr de vouloir activer {{name}} ? Cela lui donnera accès à son compte.',
        },
        buttons: {
          cancel: 'Non',
          confirm: 'Oui',
        },
        messages: {
          success: 'Statut actif modifié avec succès',
          error: 'Impossible de modifier le statut actif. Réessayez plus tard.',
        },
      },
      inviteEmployees: {
        title: 'Inviter un employé',
        confirmationTitle: 'Invitations envoyées',
        form: {
          emailField: {
            label: 'Inviter par courriel',
            placeholder:
              'Entrez un courriel ou invitez en masse en saisissant plusieurs courriels séparés par des virgules.',
            hint: 'Tous les courriels doivent correspondre au domaine de votre entreprise ({{domain}}). Pour inviter plusieurs employés, séparez les courriels individuels par des virgules.',
          },
          csvImport: '+ Importer depuis CSV',
          submit: "Envoyer l'invitation",
          errors: {
            required: 'Obligatoire.',
            invalidEmail: 'Courriel invalide {{email}}',
            invalidDomain: 'Domaine invalide {{domain}}',
            generic:
              "Une erreur s'est produite lors de l'envoi des invitations.",
            validation:
              'Veuillez corriger les erreurs ci-dessous et réessayer.',
          },
        },
        confirmation: {
          button: 'Très bien',
        },
      },
    },
  },
}
